<template>
  <div class="wrap">
    <div class="head display_between">
      <div class="nav">
        <!-- <img src="../../assets/img/icon/home.png"
             alt=""
             srcset=""
             style="margin-right:5px">
        <span @click="$router.push({name:'meetingMobile',query: { mid: mtgId }})">首页</span>
        <span></span> -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/meetingMobile?mid=' + mtgId }">
            <img src="../../assets/img/icon/home.png" alt="" srcset="" style="margin-right:5px;margin-bottom:-1px">
            <span>首页</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <span>{{ name }}</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <span @click="drawer = true" type="primary" style="margin-left: 16px;">
        菜单
      </span>
      <!-- <span @click="tagmenu">菜单</span> -->
    </div>
    <el-drawer title="我是标题" :visible.sync="drawer" :with-header="false">
      <ul class="leftMenu" @click.stop>
        <li class="menuItem" v-for="(item, index) in webSiteNaviglist" :key="index" @click.stop="tagsecond(item)">
          <span>{{ item.columnName }}</span>
        </li>
      </ul>
    </el-drawer>
    <!-- <div class="modal"
         :class="{tagClass:tagModal}"
         @click.stop="tagModal=false">
      <ul class="leftMenu"
          @click.stop>
        <li class="menuItem"
            v-for="(item,index) in menulist"
            :key="index"
            @click.stop="tagsecond(item)">
          <span>{{item.title}}</span>
          <ul class="subUl"
              v-if="item.active"
              @click.stop>
            <li class="subItem"
                v-for="(itemn,indexn) in item.secondMenus"
                :key="indexn"
                @click="menuClick(itemn)">{{itemn.title}}</li>
          </ul>
        </li>
      </ul>
    </div> -->
    <div style="padding-top: 40px ; padding-left: 1%;padding-right: 1%;">
      <div v-html="contents" @click="showImg($event)"></div>
      <!-- <component :is="tagStr"></component> -->
      <img :src="previewImg" style="display:none" ref="previewImg" preview="1">
    </div>
  </div>
</template>

<script>
// import mobiletest1 from "./mobiletest1"
// import mobiletest2 from "./mobiletest2"
import axios from 'axios'
import wx from 'weixin-js-sdk'
export default {
  name: "meetingMobileDetail",
  data() {
    return {
      ID: 0,
      tagModal: false,
      subIndex: false,
      tagStr: "mobiletest1",
      menulist: [],
      mtgId: 2,
      contents: "",
      name: '',
      drawer: false,
      webSiteNaviglist: [],
      previewImg: '',//预览图片路径,
    }
  },
  //   components: {
  //     mobiletest1,
  //     mobiletest2
  //   },
  methods: {
    tagmenu() {
      this.tagModal = !this.tagModal
    },
    tagsecond(item) {
      //   if (item.contents) {
      //     this.contents = item.contents;
      //     this.tagModal = false;
      //   }
      //   if (item.secondMenus) {
      //     item.active = !item.active
      //   }
      if (item.columnName == '参会注册' || item.columnName == '酒店预订') {
        //跳转登录页面
        this.regclick(0);
      } else if (item.columnName == '团体注册') {
        //跳转登录页面
        this.regclick(1);
      } else {

        this.$router.push({
          path: '/meetingMobileDetail',
          query: { id: item.id, mid: this.mtgId, name: item.columnName }
        });
        if (this.$route.query.id != '') {
          this.ID = this.$route.query.id
        }
        if (this.$route.query.mid != '') {
          this.mtgId = this.$route.query.mid
        }
        if (!this.isMobile()) {
          this.$router.push({
            path: '/meetingIndex',
            query: {
              mid: this.mtgId,
            },
          })
        }
        this.name = this.$route.query.name
        //获取详情
        this.GetWebSiteNavigByID();
        //获取当前会议
        this.getMeetingInfo();
        //获取分享的标题和图片    
        this.getWebSiteConfigList();
        this.drawer = false
      }
    },
    regclick(cpg) {
      if (this.$cookies.isKey('token_chinagp')) {
        var _tokenkey = this.$cookies.get('token_chinagp');
        this.httphelper
          .post('/api/LoginApi/CheckToken', {
            tokenKey: _tokenkey
          })
          .then(res => {
            if (res.data.code == 200) {
              if (res.data.data.mobile == '' || res.data.data == null) {
                this.Defconfirm();
                return;
              }
              if (cpg > 0) {
                if (!this.isDebug) {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
                } else {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
                }
              } else {
                if (!this.isDebug) {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
                } else {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
                }
              }
              // window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
            } else {
              if (!this.isDebug) {
                let callback = encodeURIComponent('https://meeting.gp519.com/reg?mtgid=' + this.mtgId);
                window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
              } else {
                let callback = encodeURIComponent('https://meeting.gp519.com/reg?mtgid=' + this.mtgId);
                window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
              }
            }
          });
      } else {
        var hrefurl = '';
        if (cpg == 0) {
          if (!this.isDebug) {
            // hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
          } else {
            hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
          }
        } else {
          if (!this.isDebug) {
            hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
          } else {
            hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
          }
        }

        let callback = encodeURIComponent(hrefurl);
        window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
      }
    },
    Defconfirm() {
      this.$confirm('会议报名必须先完善个人信息, 是否前往用户中心完善个人信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({ name: 'userInfor' });
      });
    },
    menuClick(itemn) {
      this.contents = itemn.contents;
      this.tagModal = false;
    },
    GetWebSiteNavigByID() {
      let _this = this
      this.httphelper
        .post(
          '/api/WebSiteConfigApi/GetWebSiteNavigByID',
          {
            c_Id: parseInt(_this.ID),
            type: 2,
          }
        )
        .then((res) => {
          if (res.data.code == 200) {
            res.data.data.forEach((item) => {
              if (item.id == _this.ID) {
                _this.contents = item.contents
                _this.menulist.push({ title: item.columnName, active: true, secondMenus: [], contents: item.contents })
              } else {
                _this.menulist[0].secondMenus.push({ title: item.columnName, active: true, contents: item.contents })
                _this.contents = _this.menulist[0].secondMenus[0].contents
              }
            })
            // console.log(_this.contents);
            // var reg = new RegExp(/src="([^"]*)"/g);  //正则表达式
            // console.log(_this.contents.match(reg));
            // _this.contents.replace(/src="([^"]*)"/g,
            //   (a, b, c, d, e) => {
            //     this.previewImg = b
            //     // return `${b} class="preview-img" ${c}`;
            //   }
            // );
            // console.log(111111111, this.previewImg);
            // this.arr.push(this.previewImg)
            // console.log(this.arr);
            // _this.contents = _this.contents.replace(/<img.*?>/g, ' <el-image style="width:100%;height:300px" src="' + this.previewImg + '"> </el-image>'
            // );
            // // _this.contents = _this.contents.replace(/src="([^"]*)"/g,
            // //   (a, b, c, d, e) => {
            // //     console.log(a, '____a<-_______', b, '_____b<-______', c, '____c<-_______', d, '_____d<-______', e);
            // //     // return `${b} class="preview-img" ${c}`;
            // //   }
            // // );
            // console.log('-----------', _this.contents);
          }
        })
    },
    // 判断是手机还是pc
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    getMeetingInfo() {
      let _this = this
      this.httphelper.get('/api/MeetingApi/GetMeetingInfoByID?mtgId=' + parseInt(this.mtgId)).then(res => {
        if (res.code == 200) {
          let data = res.data;

          _this.$route.meta.title = data.mtg_Name
          document.title = data.mtg_Name
          // _this.$router.replace({
          //   query: {
          //     mid: _this.mtgId,
          //     id: _this.ID,
          //     temp: Date.now()
          //   }
          // });
        }
      });
    },
    getWebSiteConfigList() {
      let _this = this
      this.httphelper
        .post(
          '/api/WebSiteConfigApi/GetWebSiteConfigList',
          {
            mtg_Id: parseInt(_this.mtgId),
            type: 2,
          }
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.webSiteNaviglist = res.data.data.webSiteNaviglist
            if (res.data.data.webSiteConfiglist != null && res.data.data.webSiteConfiglist.length > 0) {
              _this.wxshare(res.data.data.webSiteConfiglist[0]);
            }

          }
        })
    },
    // 微信分享   
    wxshare(item) {
      let urls = ''
      let userAgent = navigator.userAgent
      if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
        urls = sessionStorage.getItem('originUrl')
      } else {
        urls = window.location.href
      }
      axios
        .get(
          '/api/CGpUserApi/GetWXShareConfigInfo?url=' +
          encodeURIComponent(urls)
        )
        .then((res) => {
          wx.config({
            debug: false,
            appId: res.data.data.appid,
            timestamp: res.data.data.timestamp,
            nonceStr: res.data.data.nonceStr,
            signature: res.data.data.signature,
            jsApiList: [
              'updateAppMessageShareData',
              'updateTimelineShareData',
            ],
          })

          wx.ready(function () {
            wx.updateAppMessageShareData({
              title: item.mWebsiteTitle,
              desc: item.mWebsiteDesc == null ? '' : item.mWebsiteDesc,
              link: window.location.href,
              imgUrl: item.picturesUrl,
              type: 'link',
              dataUrl: '',
              success: function () { },
            })
            wx.updateTimelineShareData({
              title: item.mWebsiteTitle,
              desc: item.mWebsiteDesc == null ? '' : item.mWebsiteDesc,
              link: window.location.href,
              imgUrl: item.picturesUrl,
              type: 'link',
              dataUrl: '',
              success: function () { },
            })
          })
        })
    },
    showImg(e) {
      if (e.target.tagName == 'IMG') {
        this.previewImg = e.target.src
        this.$nextTick(() => {
          this.$refs.previewImg.click()
        })
      }
    },
  },
  created() {
    if (this.$route.query.id != '') {
      this.ID = this.$route.query.id
    }
    if (this.$route.query.mid != '') {
      this.mtgId = this.$route.query.mid
    }
    if (!this.isMobile()) {
      this.$router.push({
        path: '/meetingIndex',
        query: {
          mid: this.mtgId,
        },
      })
    }
    this.name = this.$route.query.name
    //获取详情
    this.GetWebSiteNavigByID();
    //获取当前会议
    this.getMeetingInfo();
    //获取分享的标题和图片    
    this.getWebSiteConfigList();
  },
  beforeRouteEnter(to, from, next) {
    let userAgent = navigator.userAgent

    if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
      sessionStorage.setItem('originUrl', location.href) // 用于ios分享
    }

    next()
  }
}
</script>
<style >
img {
  max-width: 100%;
}
</style>
<style scoped>
.head {
  position: fixed;
  z-index: 99;
  width: 100%;
  padding: 0px 20px;
  height: 40px;
  background-color: #4e88ff;
  color: #ffffff;
  box-sizing: border-box;
}

.previewImg {
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background: #000000;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
}

.previewImg img {
  width: 100vw;
}

.modal {
  position: fixed;
  z-index: 20;
  width: 100%;
  height: 100%;
  transition: all 0.6s;
  left: -100%;
  background: rgba(0, 0, 0, 0.4);
}

.leftMenu {
  width: 130px;
  background: #fff;
  height: 100%;
  list-style: none;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  padding-top: 40px;
}

.menuItem {
  display: block;
  font-size: 14px;
  padding: 0.5rem;
  color: inherit;
  border-bottom: 1px solid #f9f9f9;
  overflow: hidden;
  white-space: nowrap;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  max-width: 100%;
  box-sizing: border-box;
  padding-left: 10px;
}

.subUl {
  list-style: none;
  margin: 0;
  padding: 0;
  margin-top: 5px;
}

.subItem {
  color: #999;
  font-size: 0.55rem;
  margin-left: 0.3rem;
  padding: 0.3rem 0.5rem;
}

.tagClass {
  left: 0;
}

.nav span {
  color: #fff;
  height: 40px;
  line-height: 40px;
}
</style>
